import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import BootstrapContainer from 'react-bootstrap/Container';

const Container = ({ children = null, className = null, fluid = false }) => (
  <BootstrapContainer fluid={fluid} className={classNames('ws-ui-grid-container', className)}>
    {children}
  </BootstrapContainer>
);

Container.propTypes = {
  fluid: PropTypes.oneOf([true, false, 'sm', 'md', 'lg', 'xl', 'xxl']),
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Container;
